import { Button, ButtonGroup } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SaveButtonsContainer } from '../../components/common';
import ContentConstants from '../../contentConstants';
import { ISummaryItem } from '../../models';
import { IApplicationState } from '../../store';
import { ActionCreators as SurveyBuilderActionCreators } from '../../store/SurveyBuilderStore';

export type ButtonProps = {
	disabled?: boolean;
	text?: string;
	onClick?: (event: any) => void;
};

export const SaveButtonsGroup = (props: { children: React.ReactNode }) => {
	return (
		<SaveButtonsContainer>
			<ButtonGroup type='column'>{props.children}</ButtonGroup>
		</SaveButtonsContainer>
	);
};

export const PreviousStepButton = (props: ButtonProps) => {
	const dispatch = useDispatch();
	return (
		<Button
			id='PreviousStepButton'
			color='secondary'
			onClick={props.onClick ? props.onClick : () => dispatch(SurveyBuilderActionCreators.PreviousStep())}
			size='lg'
		>
			{ContentConstants.BUTTONS_PREVIOUS_STEP}
		</Button>
	);
};

export const SaveButton = (props: ButtonProps) => {
	const dispatch = useDispatch();
	const saving = useSelector((state: IApplicationState) => state.surveyBuilder.saving);

	return (
		<Button
			id='SaveButton'
			color='secondary'
			onClick={props.onClick ? props.onClick : () => dispatch(SurveyBuilderActionCreators.Save(false))}
			size='lg'
			disabled={props.disabled || saving}
		>
			{ContentConstants.BUTTONS_SAVE}
		</Button>
	);
};

export const SaveAndNextButton = ({ disabled }: Pick<ButtonProps, 'disabled'>) => {
	const dispatch = useDispatch();
	const saving = useSelector((state: IApplicationState) => state.surveyBuilder.saving);

	return (
		<Button
			id='SaveAndNextStepButton'
			color='primary'
			onClick={() => dispatch(SurveyBuilderActionCreators.Save(true))}
			size='lg'
			disabled={disabled || saving}
		>
			{ContentConstants.BUTTONS_SAVE_AND_NEXT}
		</Button>
	);
};

export const NextStepButton = (props: ButtonProps) => {
	const dispatch = useDispatch();

	return (
		<Button
			id='NextStepButton'
			color='primary'
			size='lg'
			onClick={props.onClick ? props.onClick : () => dispatch(SurveyBuilderActionCreators.NextStep())}
			disabled={props.disabled ? props.disabled : false}
		>
			{props.text ? props.text : ContentConstants.BUTTONS_NEXT_STEP}
		</Button>
	);
};

export type ConfirmScheduleButtonProps = {
	errorItems: ISummaryItem[] | undefined;
	toggleFinalConfirmation: () => void;
};

export const ConfirmScheduleButton = (props: ConfirmScheduleButtonProps) => {
	return (
		<Button
			id='ConfirmScheduleButton'
			size='lg'
			color='primary'
			onClick={props.toggleFinalConfirmation}
			disabled={props.errorItems && props.errorItems.length > 0}
		>
			{ContentConstants.BUTTONS_CONFIRM_SCHEDULE}
		</Button>
	);
};

export type CreateTemplateButtonProps = {
	errorItems: ISummaryItem[] | undefined;
	makeTemplatePublic: () => void;
};

export const CreateTemplateButton = (props: CreateTemplateButtonProps) => {
	return (
		<Button
			id='CreateTemplateButton'
			size='lg'
			color='primary'
			onClick={props.makeTemplatePublic}
			disabled={props.errorItems && props.errorItems.length > 0}
		>
			{ContentConstants.BUTTONS_CREATE_TEMPLATE}
		</Button>
	);
};
